module.exports = __webpack_public_path__ + "img/split-handle.e54b8a28.svg";